import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

type Kind = 'success' | 'danger';
interface Toast {
  id: number;
  kind: Kind;
  text: string;
}

const Ctx = createContext<{ notify: (kind: Kind, text: string) => void } | null>(null);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const notify = useCallback((kind: Kind, text: string) => {
    const id = Date.now() + Math.random();
    setToasts((t) => [...t, { id, kind, text }]);
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 5000);
  }, []);

  return (
    <Ctx.Provider value={{ notify }}>
      {children}
      <div
        style={{ position: 'fixed', top: 16, right: 16, zIndex: 1080, maxWidth: 380 }}
        aria-live="polite"
      >
        {toasts.map((t) => (
          <div key={t.id} className={`alert alert-${t.kind === 'danger' ? 'warning' : 'primary'} shadow-sm`}>
            {t.text}
          </div>
        ))}
      </div>
    </Ctx.Provider>
  );
}

export function useToast() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
}
